var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSftp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:#ffe082;}\n      .cls-2{fill:#039be5;}\n      .cls-3{fill:#ffb74d;}\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file transfer protocol marketing networking online") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_transfer_protocol",
    "data-name": "file transfer protocol"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,6H16.72L16,3.68A1,1,0,0,0,15,3H7a1,1,0,0,0-1,.68L5.28,6H2A1,1,0,0,0,1,7V29a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1V7A1,1,0,0,0,30,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.73,14.32l-3-3.24a1,1,0,0,0-1.46,0l-3,3.24a1,1,0,0,0,1.46,1.36L10,14.31V24a1,1,0,0,0,2,0V14.31l1.27,1.37a1,1,0,1,0,1.46-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.68,20.27a1,1,0,0,0-1.41.05L22,21.69V12a1,1,0,0,0-2,0v9.69l-1.27-1.37a1,1,0,1,0-1.46,1.36l3,3.24a1,1,0,0,0,1.46,0l3-3.24A1,1,0,0,0,24.68,20.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSftp);
export default __webpack_public_path__ + "static/media/sftp.a1029df7f8af091e13757db9012349b3.svg";
export { ForwardRef as ReactComponent };